import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=8024d02c&"
import script from "./user-register.vue?vue&type=script&lang=js&"
export * from "./user-register.vue?vue&type=script&lang=js&"
import style0 from "./user-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports